import { DEFAULT_INPUT_PREFIX } from './constants';

export const cleanInputLabel = (label: string): string => {
  return label.split(DEFAULT_INPUT_PREFIX).slice(-1)[0];
};

export const getMappedDefaultDevice = (
  devices: MediaDeviceInfo[],
  deviceWithDefaultId: MediaDeviceInfo
): MediaDeviceInfo | undefined => {
  if (deviceWithDefaultId.deviceId !== 'default') {
    return;
  }
  // The criteria for a device with a deviceId that is not 'default' to be considered
  // a default device is that it has the same groupId and a label that matches the default device label
  // with the prefix 'Default - ' removed.
  const matching = devices.find(
    (device) =>
      device.groupId === deviceWithDefaultId.groupId &&
      cleanInputLabel(deviceWithDefaultId.label) === device.label
  );
  if (matching != null) {
    return matching;
  }
};
